import { colors } from '../../partners/tokens'

export default {
  defaultProps: {
    size: 'lg',
    // px: 2,
    // pl: 3,
    // pr: 0,
  },
  variants: {
    outline: {
      _light: {
        borderColor: 'gray.400',
        borderRadius: 'lg',
        height: '48px',
        px: 4,
        py: 3,
        color: 'gray.900',
        placeholderTextColor: 'gray.600',
        _disabled: {
          opacity: '1',
        },
        _active: {
          borderColor: 'gray.600',
        },
        _hover: {
          borderColor: 'primary.500',
        },
        _focus: {
          borderColor: 'primary.500',
          backgroundColor: 'bg',
          _hover: { borderColor: 'primary.500' },
          _stack: {
            style: {
              outlineWidth: 0,
              boxShadow: `0 0 0 1px ${colors.primary[500]}`,
            },
          },
        },
      },
    },
  },
}
